<template>
    <app-layout :title="trans('vehicles.page_title.index')">
        <template #header> {{ trans("vehicles.page_title.index") }} </template>

        <Section>
            <Container>
                <div class="mb-8 flex justify-between space-x-2">
                    <Link :href="route('vehicles.create')">
                        <StyledButton background-primary>
                            {{ trans("vehicles.page_title.create") }}
                        </StyledButton>
                    </Link>
                    <div>
                        <input
                            @input="filter"
                            v-model="query"
                            type="search"
                            class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full border-gray-300 rounded-md"
                            placeholder="Suchen..."
                        />
                    </div>
                </div>

                <div>
                    <v-server-table
                        :options="options"
                        :url="route('api.vehicles.index')"
                        :columns="columns"
                        ref="table"
                    >
                        <template v-slot:vehicle="props">
                            <div class="flex items-center">
                                <div class="mr-2" v-if="!props.row.is_active">
                                    <PauseIcon class="text-red-500 w-6 h-6" />
                                </div>
                                <div>{{ props.row.vehicle }}</div>
                            </div>
                        </template>

                        <template v-slot:actions="props">
                            <vehicle-actions
                                :data="props.row"
                                :index="props.index"
                                @refresh="$refs.table.getData()"
                            ></vehicle-actions>
                        </template>
                    </v-server-table>
                </div>
            </Container>
        </Section>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import VehicleActions from "@/Pages/Vehicles/VehicleActions.vue";
import { Link } from "@inertiajs/inertia-vue3";
import { LockClosedIcon } from "@heroicons/vue/outline";
import Container from "@/Components/Container.vue";
import Section from "@/Components/Section.vue";
import StyledButton from "@/Components/StyledButton.vue";
import { PauseIcon } from "@heroicons/vue/outline";

export default {
    components: {
        AppLayout,
        VehicleActions,
        Link,
        LockClosedIcon,
        Container,
        Section,
        StyledButton,
        PauseIcon,
    },

    data() {
        return {
            query: null,
            debouncedFilter: null,
            columns: ["vehicle", "type", "plate", "actions"],
            options: {
                headings: {
                    vehicle: this.trans("vehicles.table.vehicle"),
                    type: this.trans("vehicles.table.type"),
                    plate: this.trans("vehicles.table.plate"),
                    actions: this.trans("vuetables.label.actions"),
                },

                texts: {
                    count: this.trans("vuetables.label.countText"),
                    filter: this.trans("vuetables.label.filter"),
                    noResults: this.trans("vuetables.label.noResults"),
                    loading: this.trans("vuetables.label.loading"),
                    filterPlaceholder: this.trans("vuetables.label.search"),
                },

                sortable: ["fullname"],

                columnsDisplay: {
                    email: "min_tabletP",
                },
            },
        };
    },

    methods: {
        filter() {
            this.debouncedFilter();
        },
    },

    mounted() {
        this.debouncedFilter = _.debounce(() => {
            this.$refs.table.setFilter(this.query);
        }, 300);
    },
};
</script>
